import { Chip, Tooltip } from "@mui/material";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import { esDifusorDeMencion } from "../utils/plan";

// Insignia del difusor con los envíos de 5 RC activados: el equipo revisó
// el canal donde publica (su sitio, su canal de YouTube, donde hace sus
// streams…). Ver Backend/src/utils/canales5RC.js.
export default function Insignia5RC({ tipo, size = "small", sx }) {
  const plan = esDifusorDeMencion(tipo) ? "Envíos de Mención" : "Envíos Editoriales";
  return (
    <Tooltip title={`Verificado por RadarFreim para ${plan} (5 RC)`}>
      <Chip
        icon={<WorkspacePremiumIcon />}
        label="5 RC verificado"
        size={size}
        color="primary"
        variant="outlined"
        sx={{ fontWeight: 700, ...sx }}
      />
    </Tooltip>
  );
}
